import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";

const HostSecurityGroupsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={1} marginBottom={5}>
      {entityData?.microsoft_sccm_data?.security_groups?.length > 0 &&
        entityData?.microsoft_sccm_data?.security_groups?.map(
          (securityGroup) => (
            <Box
              key={securityGroup}
              display={"flex"}
              flexDirection={"column"}
              gap={1}
            >
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <IntegrationImage
                  name={"microsoft_sccm"}
                  width={"16px"}
                  newLogo={true}
                />
                <Typography variant={"subtitle2"}>{securityGroup}</Typography>
              </Box>
            </Box>
          )
        )}
    </Box>
  );
};

export default HostSecurityGroupsView;
